import RenderAttribute from "components/PayoutManagement/previews/RenderAttribute";
import { PayoutMethodType } from "containers/PayoutManagement/types";
import React from "react";

interface ICheckPreviewProps {
  defaultPayoutMethod: PayoutMethodType;
}

const CanadianEFTPreview: React.FC<ICheckPreviewProps> = ({
  defaultPayoutMethod,
}) => {
  return (
    <>
      <RenderAttribute
        label={"First Name:"}
        value={defaultPayoutMethod.firstName || ""}
      />
      <RenderAttribute
        label={"Last Name:"}
        value={defaultPayoutMethod.lastName || ""}
      />
      <RenderAttribute
        label={"Street Address:"}
        value={`${defaultPayoutMethod.address1}, ${defaultPayoutMethod.city}, ${defaultPayoutMethod.state},${defaultPayoutMethod.country}`}
      />
      <RenderAttribute
        label={"financialInstitutionNumber"}
        value={defaultPayoutMethod?.financialInstitutionNumber || ""}
      />
      <RenderAttribute
        label={"transitNumber"}
        value={defaultPayoutMethod?.transitNumber || ""}
      />
      <RenderAttribute
        label={"accountNumber"}
        value={defaultPayoutMethod?.accountNumber || ""}
      />
      <RenderAttribute
        label={"accountName"}
        value={defaultPayoutMethod?.accountName || ""}
      />
    </>
  );
};

export default CanadianEFTPreview;
